var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68633 1.2677C1.37115 0.920281 0.924019 0.84987 0.687635 1.11044C0.45125 1.37101 0.515126 1.86388 0.830305 2.2113L3.11304 4.72757C3.30109 4.93486 3.53612 5.04354 3.74533 5.04214C3.96741 5.06488 4.22767 4.95608 4.4323 4.73051L6.71503 2.21425C7.03021 1.86682 7.09408 1.37395 6.8577 1.11338C6.62131 0.852814 6.17418 0.923225 5.859 1.27065L3.774 3.56896L1.68633 1.2677Z",
    fill: "#0BA5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.9588e33a1865031b1df63f72ed41b05e.svg";
export { ForwardRef as ReactComponent };